import type { components } from "@entities/journal";
import { formatDate } from "@shared/utils";

type SectionData = {
  section1List?: components["schemas"]["SectionOneListItemForList"][];
  permissions?: components["schemas"]["AclPermissionsInner"][];
};

export const dataSourceConfig = (sectionData: SectionData | undefined) => {
  return (
    sectionData?.section1List?.map((item: any, index: number) => {
      const {
        itemNoVersionId,
        sequenceNumber,
        company,
        userCompany,
        dateStart,
        dateEnd,
        workType,
        signer,
        status,
      } = item;

      const person = userCompany?.user;

      return {
        key: itemNoVersionId,
        number: sequenceNumber ?? index + 1,
        fullName: company?.fullName ?? "-",
        person: person
          ? `${person.surname ?? ""} ${person.firstName?.[0] ?? ""}.${person.middleName?.[0] ?? ""}.`.trim()
          : "-",
        role: person?.position ?? "-",
        startDate: formatDate(dateStart) || "-",
        workType: workType ?? "-",
        endDate: formatDate(dateEnd) || "-",
        representative: signer
          ? `${signer.surname ?? ""} ${signer.firstName?.[0] ?? ""}.${signer.middleName?.[0] ?? ""}.`.trim()
          : "-",
        representativeRole: signer?.position ?? "-",
        status: status ?? "NEW",
        rawItem: item,
      };
    }) ?? []
  );
};

